export default __webpack_public_path__ + "static/media/Equipo-orange.0ad143dd.svg";